import { graphql } from 'react-relay';

export default graphql`
  query EventListQuery_UserEvent_Pagination_Query(
    $count: Int!
    $cursor: String
    $visibility: [UserEventVisibility]
    $sortBy: EventFilterAndSort
    $booking_status: [BookingStatus]
  ) {
    viewer {
      ...EventListContainer_viewer
    }
  }
`;



// WEBPACK FOOTER //
// ./webpack/routes/EventListQuery.js